

// var userGary = null;
// var userGary = {username: 'gpajor',email:'gary.pajor@gmail.com'}

export default {
    namespaced: true,
    state: {
        user: null,
        email: ''
    },
    getters: {
        authUser(state) {
            return state.user;
        },
        authUserEmail(state) {
            return state.email;
        },
        isAuthenticated(state) {
            return !!state.user
        },

    },
    actions: {
        // loginWithEmailAndPassword({ commit }, userData) {
        //     return axios.post('/api/v1/users/login', userData)
        //         .then(res => {
        //             const user = res.data
        //             localStorage.setItem('meetuper-jwt', user.token)
        //             commit('setAuthUser', user)
        //         })
        //         .catch(err => rejectError(err))
        // },
        // registerUser(context, userData) {
        //     return axios.post('/api/v1/users/register', userData)
        //         .catch(err => rejectError(err))
        // },
        // activateUser(_, hash) {
        //     return axios.patch(`/api/v1/users/${hash}/activate`)
        // },
        // logout({ commit }) {
        //     return new Promise((resolve) => {
        //         localStorage.removeItem('meetuper-jwt')
        //         commit('setAuthUser', null)
        //         resolve(true)
        //     })
        // },
        setAuthUser({ commit }, user) {
            commit('setAuthUser', user);
        },
        setAuthUserEmail({ commit }, email) {
            commit('setAuthUserEmail', email);
        }
    },
    mutations: {
        setAuthUser(state, user) {
            state.user = user;
        },
        setAuthUserEmail(state, email) {
            state.email = email;
        },
        // setAuthState(state, authState) {
        //     return state.isAuthResolved = authState
        // },
        // setMeetupsToAuthUser(state, meetups) {
        //     return Vue.set(state.user, 'joinedMeetups', meetups)
        // }
    }
}












